export default "__VITE_ASSET__36c7c709__"